import { request } from './request';
import { saveAs } from 'file-saver';

export const getWalletPassV2 = (offerCode: string): void => {
    request('get', `wallet?quoteId=${offerCode}`, {}, {}, true).then(res => {
        saveAs(new Blob([res.data], { type: 'application/vnd.apple.pkpass' }), 'pass.pkpass');
    });
};
